// extracted by extract-css-chunks-webpack-plugin
module.exports = {"block":"block_ujXq3","blockHeader":"blockHeader_ILzky","blockTitle":"blockTitle_bCWfJ","ui_mask":"ui_mask_KcLpv"};